import { PDF_VIEWER_GET_REPORT } from "./types";
import firebase from "firebase/app";

export const getPDF = (
    type = false,
    index = false,
    uid = false,
    status = false,
    year = false,
    month = false
) => {
    return (dispatch) => {
        dispatch({
            type: PDF_VIEWER_GET_REPORT.REQUEST,
        });
        let ref = false;
        if (type === "jobpacks") {
            ref = `/subjects/jobpacks/${status}/${year}/${month}/${uid}/profile/attached_files/${index}`;
        } else if (type === "method_statement") {
            ref = `/subjects/jobpacks/${status}/${year}/${month}/${uid}/profile/job_pack_method_statement/${index}`;
        } else if (type === "tm_plan") {
            ref = `/collections/generic_tm_plans/${index}`;
        } else if (type === "company_policies") {
            ref = `/collections/company_policy/${index}`;
        } else if (type === "file_manager" && index === "equipment_documents") {
            ref = `/subjects/file_manager/equipment_documents/${uid}`;
        } else if (type === "file_manager" && index === "machine_documents") {
            ref = `/subjects/file_manager/machine_documents/${uid}`;
        } else if (type === "file_manager" && index === "help_documents"){
            ref = `/subjects/file_manager/help_documents/${uid}`;
        } else if (type === "file_manager" && index=== "qualification_documents") {
            ref = `/subjects/file_manager/qualification_documents/${uid}`;
        }else if (type === "files") {
            ref = `/subjects/files/${index}`;
        } else if (type === "file_manager") {
            ref = `/subjects/file_manager/${index}/${uid}`;
        } else ref = false;

        
        if (ref)
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user === null) {
                        dispatch({
                            type: PDF_VIEWER_GET_REPORT.FAIL,
                        });
                    } else {
                        firebase
                            .database()
                            .ref(ref)
                            .on("value", (snapshot) => {
                                let file = null;
                                if (
                                    (type === "file_manager" ||
                                        type === "files") &&
                                    snapshot.val()
                                )
                                    file = {
                                        file: snapshot.val().file_name,
                                        fileURL: snapshot.val().file_url,
                                    };
                                else file = snapshot.val();
                                /*Gets the file from old path */
                                if (file === null) {
                                    firebase
                                        .database()
                                        .ref(
                                            `/subjects/files/${uid}`
                                        )
                                        .on("value", (snapshot) => {
                                            let file = null;
                                            if (
                                                (type === "file_manager" ||
                                                    type === "files") &&
                                                snapshot.val()
                                            )
                                                file = {
                                                    file: snapshot.val()
                                                        .file_name,
                                                    fileURL: snapshot.val()
                                                        .file_url,
                                                };
                                            else file = snapshot.val();
                                            dispatch({
                                                type:
                                                    PDF_VIEWER_GET_REPORT.SUCCESS,
                                                payload: file,
                                            });
                                        });
                                } else {
                                    dispatch({
                                        type: PDF_VIEWER_GET_REPORT.SUCCESS,
                                        payload: file,
                                    });
                                }
                            });
                    }
                });
            } catch (e) {
                dispatch({
                    type: PDF_VIEWER_GET_REPORT.FAIL,
                });
            }
        else
            dispatch({
                type: PDF_VIEWER_GET_REPORT.FAIL,
            });
    };
};
